import { useMemo } from "react";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";
import { useVoronoi } from "./VoronoiContext";

export function VoronoiViewer() {
    const {
        viewBoxAttr,
        canvasW,
        canvasH,
        padding,
        cells,
        sites,
        strokeColor,
        strokeWidth,
        showSites,
        canExport,
        handleDownload,
        fillForCell,
    } = useVoronoi();

    const base = useMemo(() => {
        const [x, y, w, h] = viewBoxAttr.split(" ").map(Number);
        return { x, y, w, h };
    }, [viewBoxAttr]);

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    return (
        <div className="panel-viewer voronoi-viewer">
            <div className="path-tool-preview">
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetView}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>

                <div className="svg-scroll-wrapper">
                    <div className="svg-container svg-container--fill">
                        <svg
                            ref={svgRef}
                            viewBox={viewBox}
                            xmlns="http://www.w3.org/2000/svg"
                            className="path-tool-svg"
                            style={{ touchAction: "none" }}
                            {...panHandlers}
                        >
                            <rect
                                x={-padding}
                                y={-padding}
                                width={canvasW + padding * 2}
                                height={canvasH + padding * 2}
                                fill="white"
                            />
                            <g className="voronoi-cells">
                                {cells.map(({ pathD, index }) => (
                                    <path
                                        key={`cell-${index}`}
                                        d={pathD}
                                        fill={fillForCell(index)}
                                        stroke={strokeColor}
                                        strokeWidth={strokeWidth}
                                    />
                                ))}
                            </g>
                            {showSites && (
                                <g className="voronoi-sites">
                                    {sites.map(([x, y], i) => (
                                        <circle
                                            key={`site-${i}`}
                                            cx={x}
                                            cy={y}
                                            r={2.5}
                                            fill={strokeColor}
                                        />
                                    ))}
                                </g>
                            )}
                        </svg>
                    </div>
                </div>

                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {cells.length} cell{cells.length !== 1 ? "s" : ""} from{" "}
                        {sites.length} site{sites.length !== 1 ? "s" : ""}.
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download result SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
